import React from 'react';
import { SponsoredProduct } from 'types/sponsored-products';
import { getCurrency } from 'utils/currency';
import { useNumberFormatter } from 'common/hooks';
import { PriceBlock } from 'fronton-react';
import { calculatePriceDiscount } from 'utils/calculate-price-discount';
import { getPriceAsNumber } from 'utils/get-price-as-number';
import { getPriceType } from 'utils/get-price-type';

export const SponsoredProductPrice = React.memo((props: SponsoredProduct) => {
  const {
    price: {
      mainPrice,
      currency,
      previousPrice,
      additionalAsMain,
      additionalPrice,
      previousAdditionalPrice,
      additionalUomRus,
      mainUomRus,
    },
    productPriceCategory,
  } = props;

  const currencyFormatter = useNumberFormatter({
    options: {
      currency: currency,
      currencyDisplay: 'narrowSymbol',
      style: 'currency',
    },
  });

  const priceToDisplay = getPriceAsNumber(additionalAsMain ? additionalPrice : mainPrice) ?? 0;
  const previousPriceToDisplay = getPriceAsNumber(
    additionalAsMain ? previousAdditionalPrice : previousPrice,
  );

  const uomToDisplay = additionalAsMain ? additionalUomRus : mainUomRus;
  const currencyToDisplay = getCurrency(currencyFormatter);
  const uomCurrencyToDisplay = uomToDisplay ? `${currencyToDisplay}/${uomToDisplay}` : currencyToDisplay;

  const discount = additionalAsMain
    ? calculatePriceDiscount(additionalPrice, previousAdditionalPrice)
    : calculatePriceDiscount(mainPrice, previousPrice);

  const isPreviousPrice = additionalAsMain
    ? !!previousAdditionalPrice && !!additionalPrice && previousAdditionalPrice > additionalPrice
    : !!previousPrice && previousPrice > mainPrice;

  const priceType = getPriceType(productPriceCategory, isPreviousPrice);

  return (
    <PriceBlock
      price={priceToDisplay}
      units={uomCurrencyToDisplay}
      discount={discount}
      oldPrice={isPreviousPrice ? previousPriceToDisplay : undefined}
      type={priceType}
      size="s"
      direction="horizontal"
    />
  );
});
